<template>
  <span :class="handleClass" class="sIcon material-symbols-rounded">
    {{ icon }}
  </span>
</template>

<script lang="ts" setup>
interface IProps {
  icon: string;
  disabled?: boolean;
}
import { computed } from 'vue'
const props = defineProps<IProps>();
const handleClass = computed(() => (props.disabled ? "sIcon--disabled" : ""));
</script>

<style lang="scss" scoped>
.sIcon--disabled {
  color: --el-button-disabled-text-color;
}
</style>
